module.exports = __webpack_public_path__ + "img/circlehead.1f015384.png";